module.exports = __webpack_public_path__ + "img/atsushi-smc.1dd9ffcd.jpg";